module.exports = __webpack_public_path__ + "assets/img/2001591928118_.pic_hd.274a6770.jpg";